<template>
  <div v-if="!showMenu & (showMenu != 'undefined')">
    <!-- Page Content -->
    <div id="page-content-wrapper">
      <div>
        <!-- applicant menu start -->
        <div v-if="!currenUser.LoginInfo">
          <div class="px-3 py-2 row">
            <div
              class="col-md-1 pr"
              v-for="(menu, index) in ApplicantMenu"
              v-bind:key="index"
            >
              <b-link
                href="#"
                :to="menu.ViewURL"
                class=""
                @click="setActive(index)"
              >
                <div
                  class="menu-item"
                  :class="activeTab == index ? 'active' : ''"
                >
                  <b-icon
                    v-bind:icon="menu.ViewIcon"
                    class="rounded text-center"
                  ></b-icon
                  ><br />
                  <span class="">{{ menu.ViewName }}</span>
                </div>
              </b-link>
            </div>
          </div>
          <!-- <div class="px-3 py-2 row">
         <div class="col-md-1">
                            <b-link href="#" to="/newhome" class="active" @click="setActive(index)">
                                <div class="menu-item ">
                                    <b-icon icon="house-door" class=" rounded text-center"></b-icon><br />
                                    <span class="">Home</span>

                                </div>
                            </b-link>
                        </div>
                          <div class="col-md-1">
                            <b-link href="#" to="/APprofile" @click="setActive(index)">
                                <div class="menu-item ">
                                    <b-icon icon="person-fill" class=" rounded text-center"></b-icon><br />
                                    <span class="">Profile</span>

                                </div>
                            </b-link>
                        </div>
                                  <div class="col-md-1">
                            <b-link href="#" to="/dataapp" @click="setActive(index)">
                                <div class="menu-item ">
                                    <b-icon icon="display-fill" class=" rounded text-center"></b-icon><br />
                                    <span class="">Data</span>

                                </div>
                            </b-link>
                        </div>

                        
                        <div class="col-md-1">
                            <b-link href="#" to='/wallet' @click="setActive(index)">
                                <div class="menu-item">
                                    <b-icon icon="wallet2" class=" rounded text-center"></b-icon><br />
                                    <span class=""> Wallet</span>

                                </div>
                            </b-link>
                        </div>
                   
                   
                        <div class="col-md-1">
                            <b-link href="#" to="/Exam" @click="setActive(index)">
                                <div class="menu-item">
                                    <b-icon icon="info-circle-fill" class=" rounded text-center" ></b-icon><br />
                                    <span class=""> Exams</span>
                                </div>
                            </b-link>
                        </div>

                          <div class="col-md-1">
                            <b-link href="#" to="/tasks" @click="setActive(index)">
                                <div class="menu-item">
                                    <b-icon icon="star-fill" class=" rounded text-center"></b-icon><br />
                                    <span class=""> Tasks </span>

                                </div>
                            </b-link>
                        </div>
              
                        
                    
                    
                      <div class="col-md-1">
                            <b-link href="#" to="/Mail" @click="setActive(index)">
                                <div class="menu-item ">
                                    <b-icon icon="clock" class=" rounded text-center"></b-icon><br />
                                    <span class=""> Inbox </span>

                                </div>
                            </b-link>
                        </div>
                                <div class="col-md-1">
                            <b-link href="#" to="/Dorms" @click="setActive(index)">
                                <div class="menu-item">
                                    <b-icon icon="building" class=" rounded text-center"></b-icon><br />
                                    <span class="">Dorms</span>

                                </div>
                            </b-link>
                        </div>
                                <div class="col-md-1">
                            <b-link href="#" to="/Transportation" @click="setActive(index)">
                                <div class="menu-item ">
                                    <b-icon icon="truck" class=" rounded text-center"></b-icon><br />
                                    <span class="">Transportation</span>

                                </div>
                            </b-link>
                        </div>
                        
                         </div> -->
        </div>
        <!-- end Applicant menu-->
        <div v-if="currenUser.LoginInfo">
          <div class="px-3 py-2 row">
            <div
              class="col-md-1"
              v-for="(menu, index) in currenUser.LoginInfo"
              v-bind:key="index"
            >
              <b-link
                href="#"
                :to="menu.ViewURL"
                class=""
                @click="setActive(index)"
              >
                <div
                  class="menu-item"
                  :class="activeTab == index ? 'active' : ''"
                >
                  <b-icon
                    v-bind:icon="menu.ViewIcon"
                    class="rounded text-center"
                  ></b-icon
                  ><br />
                  <span class="">{{ menu.ViewName }}</span>
                </div>
              </b-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      ShowMenu: true,
      activeTab:
        localStorage.getItem("activeTab") != null
          ? parseInt(localStorage.getItem("activeTab"))
          : 0,
      ApplicantMenu: [
        {
          ViewName: "Home",
          ViewURL: "/newhome",
          ViewIcon: "house-door",
        },
        {
          ViewName: "Profile",
          ViewURL: "/APprofile",
          ViewIcon: "person-fill",
        },
        {
          ViewName: "Data",
          ViewURL: "/Dataapp",
          ViewIcon: "display-fill",
        },
        {
          ViewName: "wallet",
          ViewURL: "/wallet",
          ViewIcon: "wallet2",
        },
        {
          ViewName: "Exams",
          ViewURL: "/Exam",
          ViewIcon: "info-circle-fill",
        },
        {
          ViewName: "Tasks",
          ViewURL: "/tasks",
          ViewIcon: "star-fill",
        },
        {
          ViewName: "Inbox",
          ViewURL: "/Mail",
          ViewIcon: "mailbox",
        },
        {
          ViewName: "Dorms",
          ViewURL: "/Dorms",
          ViewIcon: "building",
        },
        {
          ViewName: "Transportation",
          ViewURL: "/Transportation",
          ViewIcon: "truck",
        },
    
      ],
    };
  },
  computed: {
    currenUser() {
      return this.$store.state.auth.user;
    },
    showMenu() {
      return this.$store.state.auth.Menuhide;
    },
  },
  mounted() {
    this.showMenu;
  },
  methods: {
    logOut() {
      this.$store.dispatch("auth/logout");
      this.$router.push("/login");
    },
    Menu() {
      this.showMenu;
    },
    setActive(index) {
      this.activeTab = index;
      localStorage.setItem("activeTab", index);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.px-3 > .col-md-1 {
  min-width: fit-content !important;
  padding-left: 0;
  padding-right: 10px;
}

.btn-menu {
  cursor: pointer;
  height: 140px !important;
  width: 40px !important;
  font-size: 18px;
  position: absolute;
  left: 0 !important;
  background: #f2b36d;
  color: #285475;
  font-weight: bold;
  text-align: center;

  border-radius: 0px 10px 10px 0px;
  padding-top: 20px;
}

.b-icon.bi {
  color: #ff8600;
}
a:link {
  text-decoration: none;
}

.active {
  color: #fff !important;
  background-color: #144163 !important;
}
.text {
  -ms-transform: rotate(270deg); /* IE 9 */
  transform: rotate(270deg);
}

button[aria-expanded="true"] {
  left: 320px !important;
  transition: all 0.5s ease 0s;
  -webkit-transition: all 0.5s ease 0s;
  position: fixed;
}

button[aria-expanded="false"] {
  left: 0px !important;
  transition: 0.37s;
}

.b-sidebar {
  transition: all 0.9s ease 0s !important;
  -webkit-transition: all 0.9s ease 0s !important;
}
button.not-collapsed {
  left: 320 !important;
}

.user-Iocn {
  width: 100px;
  height: 100px;
  border-radius: 50% !important;
}

.bg-menu {
  background-color: #144163 !important;
  color: #fff !important;
}

.bg-dark {
  background-color: #0080ff !important;
}

.menu-item {
  border-radius: 10px;
  border: 2px solid #ff8600;

  /* background: url(https://picsum.photos/500/500/?image=54); */
  padding: 5px;
  font-size: 1rem;
  text-align: center;
  color: #295677;
  min-width: 100px;
  min-height: 78px;
  background-image: none;
  background: #fff;
  object-fit: fill;
  box-shadow: 0 4px 8px 0 rgb(0 0 0 / 8%), 0 6px 20px 0 rgb(0 0 0 / 8%);
}

.menu-item {
  text-shadow: none !important;
}

a .menu-item {
  color: #295677;
  text-decoration: none !important;
  font-weight: bold;
}

.exambg {
  background: url("../assets/Exam.png");
  background-repeat: no-repeat;
  background-size: cover;
}

.Walletbg {
  background: url("../assets/wallet.png");
  background-repeat: no-repeat;
  background-size: cover;
}
.Schedulebg {
  background: url("../assets/Schedule.png");
  background-repeat: no-repeat;
  background-size: cover;
}

.Notificationsbg {
  background: url("../assets/Notifications.png");
  background-repeat: no-repeat;
  background-size: cover;
}

.Gradesbg {
  background: url("../assets/Grades.png");
  background-repeat: no-repeat;
  background-size: cover;
}

.Resturantbg {
  background: url("../assets/Resturant.png");
  background-repeat: no-repeat;
  background-size: cover;
}

.Transportationbg {
  background: url("../assets/Transportation.png");
  background-repeat: no-repeat;
  background-size: cover;
}

.Militarybg {
  background: url("../assets/military.png");
  background-repeat: no-repeat;
  background-size: cover;
}

.Ticketbg {
  background: url("../assets/Ticket.png");
  background-repeat: no-repeat;
  background-size: cover;
}
.homebg {
  background: url("../assets/bg-body.jpg");
  background-repeat: no-repeat;
  background-size: cover;
}

.Resturantbg {
  background: url("../assets/Resturant.png");
  background-repeat: no-repeat;
  background-size: cover;
}

.Roombg {
  background: url("../assets/Room.png");
  background-repeat: no-repeat;
  background-size: cover;
}

.Eventbg {
  background: url("../assets/Event.png");
  background-repeat: no-repeat;
  background-size: cover;
}

.b-sidebar-body {
  overflow-x: hidden !important;
}

.smallest {
  font-size: 57%;
  font-weight: 400;
}
.b-sidebar > .b-sidebar-body {
  overflow-x: hidden !important;
}
@media only screen and (max-width: 700px) {
  .exambg {
    background-position: center !important;
    border: 1px solid #eee;
  }
  .Walletbg {
    background-position: center !important;
    border: 1px solid #eee;
  }
  .Eventbg {
    background-position: center !important;
    border: 1px solid #eee;
  }
  .Schedulebg {
    background-position: center !important;
    border: 1px solid #eee;
  }
  .Gradesbg {
    background-position: center !important;
    border: 1px solid #eee;
  }
}
.iconMenu {
  padding-right: 2px;
  position: absolute;
  left: -28px;
  top: 2px;
}
</style>

